module.exports = __webpack_public_path__ + "public/img/zs1.95815858.png";